import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appFallbackImage]'
})
export class FallbackImageDirective {

    @Input('fallbackImage') fallbackImage: string;
    @Input('nodeType') nodeType: string;

  constructor(private el: ElementRef) {
  }

  @HostListener('error') loadFallbackImage() {
      const imageElement: HTMLImageElement = this.el.nativeElement as HTMLImageElement;

      if (this.nodeType && this.nodeType === 'chatHub') {
          imageElement.src = '../../../../../assets/svg/redesign/nodes/right-panel/chatHub_rsb_fallback.svg';
      } else {
          imageElement.src = '';
      }
  }
}
